import { supabase } from '../config/supabase.js'

// Generic CRUD operations for Supabase
export class DataService {
  constructor(tableName) {
    this.tableName = tableName
  }

  // Get all records
  async getAll() {
    try {
      const { data, error } = await supabase
        .from(this.tableName)
        .select('*')
        .order('created_at', { ascending: false })

      if (error) throw error
      return data
    } catch (error) {
      console.error(`Error fetching ${this.tableName}:`, error)
      throw error
    }
  }

  // Get record by ID
  async getById(id) {
    try {
      const { data, error } = await supabase
        .from(this.tableName)
        .select('*')
        .eq('id', id)
        .single()

      if (error) throw error
      return data
    } catch (error) {
      console.error(`Error fetching ${this.tableName} by ID:`, error)
      throw error
    }
  }

  // Create new record
  async create(record) {
    try {
      const { data, error } = await supabase
        .from(this.tableName)
        .insert(record)
        .select()

      if (error) throw error
      return data[0]
    } catch (error) {
      console.error(`Error creating ${this.tableName}:`, error)
      throw error
    }
  }

  // Update record
  async update(id, updates) {
    try {
      const { data, error } = await supabase
        .from(this.tableName)
        .update(updates)
        .eq('id', id)
        .select()

      if (error) throw error
      return data[0]
    } catch (error) {
      console.error(`Error updating ${this.tableName}:`, error)
      throw error
    }
  }

  // Delete record
  async delete(id) {
    try {
      const { error } = await supabase
        .from(this.tableName)
        .delete()
        .eq('id', id)

      if (error) throw error
      return true
    } catch (error) {
      console.error(`Error deleting ${this.tableName}:`, error)
      throw error
    }
  }

  // Toggle active status
  async toggleActive(id) {
    try {
      const { data: current } = await this.getById(id)
      if (current) {
        return await this.update(id, { active: !current.active })
      }
    } catch (error) {
      console.error(`Error toggling ${this.tableName} status:`, error)
      throw error
    }
  }
}

// Specific service instances
export const offersService = new DataService('offers')
export const galleryService = new DataService('gallery')
export const promotionsService = new DataService('promotions')
export const messagesService = new DataService('messages')
export const landingPhotosService = new DataService('landing_photos')
export const heroVideoService = new DataService('hero_video')
export const siteSettingsService = new DataService('site_settings')
export const adminCredentialsService = new DataService('admin_credentials')
export const pushNotificationsService = new DataService('push_notifications')